
import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search } from "lucide-react";
import { toast } from "sonner";

interface Address {
  cep: string;
  logradouro: string;
  bairro: string;
  localidade: string;
  uf: string;
}

interface CepInputProps {
  onAddressFound: (address: Address) => void;
  value?: string;
  onChange?: (value: string) => void;
  className?: string;
}

const CepInput = ({ onAddressFound, value, onChange, className }: CepInputProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const fetchAddress = async () => {
    // Remover caracteres não numéricos
    const cepClean = (value || "").replace(/\D/g, "");
    
    if (cepClean.length !== 8) {
      toast.error("CEP inválido. Insira um CEP com 8 dígitos.");
      return;
    }

    setIsLoading(true);
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cepClean}/json/`);
      const data = await response.json();
      
      if (data.erro) {
        toast.error("CEP não encontrado");
        return;
      }
      
      onAddressFound({
        cep: data.cep,
        logradouro: data.logradouro,
        bairro: data.bairro,
        localidade: data.localidade,
        uf: data.uf
      });
      
      toast.success("Endereço encontrado com sucesso!");
    } catch (error) {
      toast.error("Erro ao buscar o endereço");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();
      fetchAddress();
    }
  };

  return (
    <div className="cep-input-group flex w-full">
      <Input
        type="text"
        placeholder="CEP"
        value={value || ""}
        onChange={(e) => onChange && onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        maxLength={9}
        className={`flex-1 ${className || ''}`}
      />
      <Button 
        type="button" 
        onClick={fetchAddress} 
        disabled={isLoading}
        size="icon"
        className="ml-2"
      >
        <Search className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default CepInput;
